import res, { currentYear } from './res'

res.add('en', {
    copyright1: 'Лицензия на проведение банковских и иных операций и деятельности на рынке ценных бумаг № 1.2.47/230/38/1 от 3 февраля 2020 года',
    copyright2: `© ${currentYear} АО "Народный Банк Казахстана"`
})
